module.exports = __webpack_public_path__ + "static/media/Logo-Musty.676c7c62.png";